<template>
  <!-- 点検報告書確認 -->
  <div id="AppReportPreview">
    <!-- 上部余白 -->
    <div style="height: 10px" />
    <div class="box" style="margin-left: 50px; margin-right: 50px">
      <!-- ヘッダー部 -->
      <div class="columns">
        <div class="column is-full">
          <label ref="title" class="searchTitle label">点検報告書確認</label>
        </div>
      </div>

      <!-- 情報部 -->
      <div class="columns">
        <div class="column" style="text-align: left">
          <table class="table is-full" style="width: 100%">
            <tr>
              <th style="border-bottom: solid 1px; width: 150px">
                受け渡し種別
              </th>
              <td style="border-bottom: solid 1px">
                <b-select
                  v-if="!sendTypeDisabled"
                  v-model="currentItem.sendType"
                >
                  <option
                    v-for="sendType in sendTypes"
                    :value="sendType.code"
                    :key="sendType.code"
                  >
                    {{ sendType.name }}
                  </option>
                </b-select>
                <span v-else>{{
                  currentItem.sendType | sendTypeFillterCommon(currentItem.kind)
                }}</span>
              </td>
            </tr>

            <tr>
              <th style="border-bottom: solid 1px; width: 150px">ステータス</th>
              <td style="border-bottom: solid 1px">
                <span>{{ currentItem.status | printingStatusFillter() }}</span>
                <b-icon v-if="nextStatusName" icon="arrow-right" size="is-small" style="margin-left: 20px"></b-icon>
                <b-checkbox
                  style="padding-left: 20px"
                  v-if="nextStatusName"
                  v-model="currentItem.changeStatus"
                  >{{ nextStatusName }}</b-checkbox
                >
              </td>
            </tr>
          </table>
        </div>
      </div>

      <!-- 操作部 -->
      <div class="columns">
        <div class="column" style="text-align: left">
          <b-button
            v-on:click="back()"
            class="button"
            type="is-primary"
            native-type="button"
            >戻る</b-button
          >
          <b-button
            v-on:click="update()"
            class="button"
            type="is-primary"
            native-type="button"
            >更新</b-button
          >
        </div>
        <div class="column" style="text-align: right">
          <b-button
            v-on:click="gotoPrevPage()"
            class="button"
            type="is-primary"
            native-type="button"
            :disabled="isTopPage"
            >前頁</b-button
          >
          <b-button
            v-on:click="gotoNextPage()"
            class="button"
            type="is-primary"
            native-type="button"
            :disabled="isLastPage"
            >次頁</b-button
          >
        </div>
      </div>

      <!-- プレビュー部 -->
      <div class="columns">
        <div class="column" style="text-align: center">
          <iframe
            ref="preview"
            style="width: 100vw; height: 100vh"
            :src="url"
            type="application/pdf"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const constInspection = require("../utils/inspection");
const constUser = require("../utils/user");

export default {
  name: "AppReportPreview",

  computed: {
    isTopPage: function () {
      let isTopPage = this.currentItemIdx == 0 ? true : false;
      return isTopPage;
    },

    isLastPage: function () {
      let isLastPage =
        this.currentItemIdx == this.items.length - 1 ? true : false;
      return isLastPage;
    },

    sendTypes: function () {
      let sentTypes;
      switch (this.currentItem.kind) {
        case constInspection.PRINT_TYPE_MAP.patient.code:
          sentTypes = constInspection.SEND_TYPES_PATIENT;
          break;
        case constInspection.PRINT_TYPE_MAP.hospital.code:
          sentTypes = constInspection.SEND_TYPES_HOSPITAL;
          break;
      }

      return sentTypes;
    },

    sendTypeDisabled: function () {
      let sendTypeDisabled = true;
      // コールセンターは当該画面に到達しないためロール未チェック
      switch (this.currentItem.status) {
        case constInspection.PRINT_STATUS_MAP.notOutput.code:
        case constInspection.PRINT_STATUS_MAP.confirmed.code:
          sendTypeDisabled = false;
          break;
      }
      return sendTypeDisabled;
    },

    nextStatusName: function () {
      let canStatusChange = false;
      let nextStatusName;

      // ステータス変更可否判定
      switch (this.userInfo.roleId) {
        case constUser.ROLE_ID_MAP.systemManager:
        case constUser.ROLE_ID_MAP.inspectionManager:
        case constUser.ROLE_ID_MAP.inspector:
          canStatusChange = true;
          break;
        default:
          switch (this.userInfo.positionCode) {
            case constUser.POSITION_ID_MAP.soc:
            case constUser.POSITION_ID_MAP.sales:
            case constUser.POSITION_ID_MAP.branchMgr:
              canStatusChange = true;
              break;
          }
      }

      // 次ステータス名決定
      if (canStatusChange) {
        if (
          this.currentItem.sendType ==
          constInspection.SEND_TYPE_HOSPITAL_MAP.pcp.code
        ) {
          switch (this.currentItem.status) {
            case constInspection.PRINT_STATUS_MAP.notOutput.code:
            case constInspection.PRINT_STATUS_MAP.confirmed.code:
              nextStatusName =
                constInspection.PRINT_STATUS_MAP.outputedPcp.name;
              break;
            case constInspection.PRINT_STATUS_MAP.outputedPcp.code:
              nextStatusName = constInspection.PRINT_STATUS_MAP.confirmed.name;
              break;
          }
        } else {
          switch (this.currentItem.status) {
            case constInspection.PRINT_STATUS_MAP.notOutput.code:
              nextStatusName = constInspection.PRINT_STATUS_MAP.confirmed.name;
              break;
          }
        }
      }

      return nextStatusName;
    },
  },

  methods: {
    back: function (event) {
      this.$router.push({
        name: "AppReportbatchPrintSearch",
        params: {
          searchConditions: this.$route.params["searchConditions"],
        },
      });

      return;
    },

    update: function (event) {
      // WebAPI呼び出し
      this.apiCall(
        this.putInspectionReportsPUT,
        this.putInspectionReportsPUTsuccess,
        this.putInspectionReportsPUTerror
      );

      return;
    },

    gotoPrevPage: async function () {
      --this.currentItemIdx;
      this.currentItem = this.items[this.currentItemIdx];
      const loaded = await this.loadFile();
      if (!loaded) {
        ++this.currentItemIdx;
      }
    },

    gotoNextPage: async function () {
      ++this.currentItemIdx;
      this.currentItem = this.items[this.currentItemIdx];
      const loaded = await this.loadFile();
      if (!loaded) {
        --this.currentItemIdx;
      }
    },

    loadFile: async function () {
      if (!this.currentItem.existsInspectionReportFile) {
        const confiermRes = await this.showComfirmMessage(
          "点検報告書の保存期間を超過しているため、表示に時間が掛かる場合があります。\n処理を継続しますか？"
        );
        if (!confiermRes) {
          return false;
        }
      }

      this.createUrl();

      return true;
    },

    createUrl: function () {
      this.url = window.location.origin + "/webapi/v1/getInspectionReportFile?";
      this.url += "reservationId=" + this.currentItem.appointmentCode;
      this.url += "&inspectionId=" + this.currentItem.inspectionCode;
      this.url += "&printType=" + this.currentItem.kind;
      this.url += "&sendType=" + this.currentItem.sendType;
      this.url += "#toolbar=0";

      for (const item of this.items) {
        if (
          this.currentItem.appointmentCode == item.appointmentCode &&
          this.currentItem.inspectionCode == item.inspectionCode &&
          this.currentItem.kind == item.kind &&
          this.currentItem.sendType == item.sendType
        ) {
          item.existsInspectionReportFile = true;
        }
      }

      return;
    },

    putInspectionReportsPUT: async function (client) {
      const inspectionReports = [];
      const notExistsPcpHospitals = [];
      for (const item of this.items) {
        let notExistsPcpHospital;
        const inspectionReport = {};
        inspectionReport.reservationId = Number(item.appointmentCode);
        inspectionReport.inspectionId = Number(item.inspectionCode);
        inspectionReport.printType = item.kind;
        inspectionReport.sendType = item.sendType;
        inspectionReport.destinationId = item.destinationId;
        if (item.changeStatus) {
          if (
            item.sendType == constInspection.SEND_TYPE_HOSPITAL_MAP.pcp.code
          ) {
            switch (item.status) {
              case constInspection.PRINT_STATUS_MAP.notOutput.code:
              case constInspection.PRINT_STATUS_MAP.confirmed.code:
                if (!item.pcpHospitalNum) {
                  notExistsPcpHospital = notExistsPcpHospitals.find((elem) => elem.hospitalCode == item.hospitalCode);
                  if (!notExistsPcpHospital) {
                    notExistsPcpHospital = {
                      hospitalCode: item.hospitalCode,
                      hospitalName: item.hospitalName,
                    };
                    notExistsPcpHospitals.push(notExistsPcpHospital);
                  }
                }
                inspectionReport.status =
                  constInspection.PRINT_STATUS_MAP.outputedPcp.code;
                break;
              case constInspection.PRINT_STATUS_MAP.outputedPcp.code:
                inspectionReport.status =
                  constInspection.PRINT_STATUS_MAP.confirmed.code;
                break;
            }
          } else {
            switch (item.status) {
              case constInspection.PRINT_STATUS_MAP.notOutput.code:
                inspectionReport.status =
                  constInspection.PRINT_STATUS_MAP.confirmed.code;
                break;
            }
          }
        }

        if (!notExistsPcpHospital) {
          inspectionReports.push(inspectionReport);
        }
      }

      if (notExistsPcpHospitals.length) {
        let message = "PCPの呼吸点検報告書サービスを利用していない以下の医療機関には公開できません。\n";
        message += "該当する医療機関を除いて、処理を継続しますか？\n\n";
        for (const notExistsPcpHospital of notExistsPcpHospitals) {
          message += "・" + notExistsPcpHospital.hospitalCode + ": " + notExistsPcpHospital.hospitalName + "\n";
        }
        const appVue = this.$root.$children[0];
        appVue.loadingEnd();
        const res = await this.showComfirmMessage(message);
        if (!res) {
          return null;
        }
        appVue.loadingStart();
      }

      const apiRes = client.apis.apiInspection.putInspectionReportsPUT({
        body: {
          inspectionReports: inspectionReports,
        },
      });
      return apiRes;
    },

    putInspectionReportsPUTsuccess: async function (result) {
      if (!result) {
        return;
      }

      for (const item of this.items) {
        if (item.changeStatus) {
          item.changeStatus = false;
          if (
            item.sendType == constInspection.SEND_TYPE_HOSPITAL_MAP.pcp.code
          ) {
            switch (item.status) {
              case constInspection.PRINT_STATUS_MAP.notOutput.code:
              case constInspection.PRINT_STATUS_MAP.confirmed.code:
                if (item.pcpHospitalNum) {
                  item.status = constInspection.PRINT_STATUS_MAP.outputedPcp.code;
                }
                break;
              case constInspection.PRINT_STATUS_MAP.outputedPcp.code:
                item.status = constInspection.PRINT_STATUS_MAP.confirmed.code;
                break;
            }
          } else {
            switch (item.status) {
              case constInspection.PRINT_STATUS_MAP.notOutput.code:
                item.status = constInspection.PRINT_STATUS_MAP.confirmed.code;
                break;
            }
          }
        }
      }
      this.showSuccess(result);
      return;
    },

    putInspectionReportsPUTerror: function (result) {
      this.showErrorMessage(result);
      return;
    },
  },

  data() {
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    const items = this.$route.params["items"];
    let data = {
      userInfo: userInfo,
      items: items,
      currentItemIdx: 0,
      currentItem: items[0],
      url: null,
    };
    return data;
  },

  mounted: async function () {
    const loaded = await this.loadFile();
    if (!loaded) {
      this.back();
    }

    return;
  },

  filters: {},
};
</script>

<style lang="scss" scoped>
.previewArea {
  #toolbar {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppReportPreview.vue